// extracted by mini-css-extract-plugin
export default {"header":"SideCart_header__+3L70","empty":"SideCart_empty__JpSf7","total":"SideCart_total__KxXzO","cart-btns":"SideCart_cart-btns__ugAO3"};